import React from 'react';
import { X } from 'lucide-react';
import { FracasIncident } from '../../types/fracas.types';

interface LabRequestModalProps {
    isOpen: boolean;
    onClose: () => void;
    onCreate: () => void;
    incident: FracasIncident;
}

export const LabRequestModal: React.FC<LabRequestModalProps> = ({
    isOpen,
    onClose,
    onCreate,
    incident
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-bold text-gray-900">Request Lab Testing</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <div className="space-y-4">
                    <div>
                        <p className="text-sm text-gray-600 mb-2">Product</p>
                        <p className="font-medium">{incident.productName}</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-600 mb-2">Failure Mode</p>
                        <p className="font-medium">{incident.failureMode || 'Not specified'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-600 mb-2">Tests</p>
                        <div className="flex flex-wrap gap-2">
                            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Failure Analysis</span>
                            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Root Cause Investigation</span>
                        </div>
                    </div>
                    <div className="flex gap-2 pt-4">
                        <button
                            onClick={onCreate}
                            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            Create Lab Sample
                        </button>
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
